module.exports = __webpack_public_path__ + "media/images/hero/hero2-28323ab34c71948778477bc32fb85312.png";